import {createSlice,configureStore} from "@reduxjs/toolkit"
const lng=require("./lng.json")
//creation d'un morçeau avec un nom, une valeur ititiale, et des actions
const lngSlice=createSlice({
    name:"info",
    initialState:
       lng[localStorage.getItem('lng')!=null?localStorage.getItem('lng'):"FR"],
    
    reducers:{
        changeLng:(state,action)=>{
            //{type:"info/addInfo", payload: "info?"}
            
            state=lng[action.payload]
            
            return state;

        }
    }
})
//exposition des fonctions
export const{changeLng}=lngSlice.actions;
//encapsulation des actions 
export const store=configureStore({
    reducer:lngSlice.reducer
});